<af-full-table class="w-100 h-100"
               [showImport]="false"
               [showExport]="false"
               [dataSource]="dataSource"
               (tableUpdateListener)="loadRefunds($event)"
               [columnTranslationPrefixes]="{id: 'refunds', status:'refunds'}"
               (emptyStateClickListener)="createRefundListener.emit()"
               [filterEvent]="tableEvent.filter"
               [pageEvent]="tableEvent.page"
               [filterFields]="filterFields"
               [hasFilterContent]="true"
               emptyStateIconName="ic_empty_state_no_refunds"
               emptyStateTitleTranslationKey="i18n_af_emptyStateTitleRefundsNotCreated"
               emptyStateSubtitleTranslationKey="i18n_af_emptyStateSubtitleRefundsNotCreated"
               [emptyStateButtonLabel]="hasCreateButton ? 'i18n_af_buttonCreateRefund' : null"
               placeholderContext="incidentRefunds">
    <div FilterContent fxLayout="row" fxLayoutAlign="center center" class="pl-16" fxLayoutGap="16px">
        <ui-kit-svg class="i-16 pointer"
                    name="ic_new_tab"
                    (click)="navigateToRefunds()"/>
        @if (hasCreateButton) {
            <ui-kit-button [label]="'i18n_af_buttonCreateNewRefund' | translate"
                           [removePadding]="true"
                           type="text"
                           iconPosition="left"
                           size="small"
                           icon="ic_plus_ellipse"
                           (clickListener)="createRefundListener.emit()"/>
        }
    </div>
</af-full-table>
